<div [id]="id()" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <form #form novalidate (ngSubmit)="onSubmit()">
        <div class="relative w-[391px] max-h-full rounded-lg p-6 bg-primary-purple-light-2">
            @if (editing() == false) {
            <section class="flex justify-center items-center">
                <h3 class="w-full text-base font-bold text-primary-purple">{{ availabilitiesSelected()! > 1 ? literalService.get('availabilities.actions.editAvailabilities.titleMultiple', true) + ': ' + availabilitiesSelected()! : literalService.get('availabilities.actions.editAvailabilities.title', true) }}</h3>
                <button (click)="modal()?.hide()" type="button" class="absolute right-2 mr-4 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                    <img [src]="images.close" class="h-6 w-6" />
                </button>
            </section>
            <section class="mt-8">
                <div>
                    <div class="flex items-center mb-[6px]">
                        <img [src]="images.driver" alt="driver" class="h-6 w-6 mr-[6px]">
                        <label class="font-normal text-base text-primary-purple">{{ literalService.get('availabilities.actions.editAvailabilities.data.driver', true) }}</label>
                    </div>
                    <app-driver-select [clientId]="clientId()" [value]="driverSelected()" [extraOptions]="assignedDriverOption()" (driverSelected)="changeDriver($event)" />
                </div>
                <div class="mt-6">
                    <div class="flex items-center mb-[6px]">
                        <img [src]="images.vehicle" alt="vehicle" class="h-6 w-6 mr-[6px]">
                        <label class="font-normal text-base text-primary-purple">{{ literalService.get('availabilities.actions.editAvailabilities.data.vehicle', true) }}</label>
                    </div>
                     <app-vehicle-select [clientId]="clientId()" [value]="vehicleSelected()" [extraOptions]="assignedVehicleOption()" (vehicleSelected)="changeVehicle($event)" />
                </div>
                <div class="mt-6">
                    <div class="flex items-center mb-[6px]">
                        <img [src]="images.clock" alt="clock" class="h-6 w-6 mr-[6px]">
                        <label class="font-normal text-base text-primary-purple">{{ literalService.get('availabilities.data.startDateTime', true) }}</label>
                    </div>
                    <input type="time" [(ngModel)]="timeSelected" class="flex mb-2 w-full h-12 px-3 py-2 bg-white border rounded-s rounded-e font-normal placeholder-slate-400 focus:outline-none" (change)="changeTime($event)" autocomplete="one-time-code" />
                </div>
                <div class="mt-6">
                    <div class="flex items-center mb-[6px]">
                        <img [src]="images.comment" alt="comment" class="h-6 w-6 mr-[6px]">
                        <label class="font-normal text-base text-primary-purple">{{ literalService.get('driverComment', true) }}</label>
                    </div>
                    <textarea [value]="commentSelected() || ''" (change)="changeComment($event)" [placeholder]="literalService.get('maxChar150Optional', true)" class="block w-full h-24 px-3 py-2 bg-white border rounded-s rounded-e font-normal placeholder-slate-400 focus:outline-none"></textarea>
                </div>
                @if (availabilitiesSelected()! > 1) {
                    <div class="flex items-center mt-2 hidden!">
                        <img [src]="images.info" class="h-4 w-4 mr-1" />
                        <label class="font-normal text-[11px]">{{ literalService.get('availabilities.actions.editAvailabilities.info', true) }}</label>
                    </div>
                }
                @if (hasTrips()) {
                    <div class="flex items-center justify-between mt-6">
                        <div class="flex gap-2 items-center">
                            <img [src]="images.availabilities.trip" alt="trip" class="h-6 w-6" />
                            <label class="font-bold">{{ literalService.get('availabilities.actions.updateTrips', true) }}</label>
                        </div>
                        <app-toggle [id]="'updateTrips'" [checked]="updateTrips" (change)="updateTrips = !updateTrips;" [disabled]="timeSelected() !== undefined"></app-toggle>
                    </div>
                }
                @if (updateTrips && hasBookings() && timeSelected() !== undefined) {
                    <div class="flex items-center justify-between mt-6">
                        <div class="flex gap-2 items-center">
                            <img [src]="images.booking.notifications" alt="notify" class="h-6 w-6" />
                            <label class="font-bold">{{ literalService.get('bookings.actions.deleteBooking.notify', true) }}</label>
                        </div>
                        <app-toggle [id]="'notify'" [checked]="notify" (change)="notify = !notify;"></app-toggle>
                    </div>
                }
            </section>
            <section class="flex justify-between items-center mt-8">
                <button type="button" class="secondary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer mr-1" (click)="modal()?.hide()">{{ literalService.get('cancel', true) }}</button>
                <button type="submit" class="primary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer ml-1">{{ literalService.get('modify', true) }}</button>
            </section>
        } @else if (editing() == true) {
            <div>
                <article class="flex w-full pb-6 pt-4 ml-10 pl-7 pr-7 justify-center items-center">
                    <ng-lottie width="75%" height="75%" [options]="optionsBus" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
                </article>
                <div class="flex items-center justify-center">
                    <h3 class="text-xl font-bold mb-4 -mt-4 text-primary-purple-light">{{ literalService.get('editingAvailabilities', true)}}</h3>
                </div>
            </div>
        }
        </div>
    </form>
</div>